var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cards__list" },
    _vm._l(_vm.workoutsOfDay, function(workout) {
      return _c("div", { key: workout.title, staticClass: "card" }, [
        _c("div", { staticClass: "img" }, [
          _c("img", {
            attrs: {
              src: "" + _vm.contentUrl + workout.baseUrl + "/cover.png",
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("h3", [_vm._v(_vm._s(workout.title))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(workout.exercises.length) +
                " " +
                _vm._s(_vm.$t("profile.exercises.exercisesNum")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card__action",
              on: {
                click: function($event) {
                  return _vm.handleCardAction(workout)
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("profile.home.start")) + "\n      "
              )
            ]
          )
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }